/**
 * @generated SignedSource<<2d648b5c9faf0c2836c839b0b47995f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type SpaceStatus = "CLOSED" | "OPEN" | "%future added value";
export type UnlockRequestStatus = "ERROR" | "EXECUTED" | "PENDING" | "TIMED_OUT" | "UNLOCKED" | "%future added value";
export type DoorUnlockPollingQuery$variables = {
  unlockRequestId: string;
};
export type DoorUnlockPollingQuery$data = {
  readonly unlockRequest: {
    readonly error: string | null | undefined;
    readonly id: string;
    readonly reservation: {
      readonly space: {
        readonly hub: {
          readonly status: HubStatus;
        };
        readonly id: string;
        readonly status: SpaceStatus;
      };
    };
    readonly status: UnlockRequestStatus;
    readonly unlockedAt: any | null | undefined;
  } | null | undefined;
};
export type DoorUnlockPollingQuery = {
  response: DoorUnlockPollingQuery$data;
  variables: DoorUnlockPollingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unlockRequestId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "unlockRequestId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unlockedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Hub",
      "kind": "LinkedField",
      "name": "hub",
      "plural": false,
      "selections": [
        (v3/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DoorUnlockPollingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UnlockRequest",
        "kind": "LinkedField",
        "name": "unlockRequest",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "reservation",
            "plural": false,
            "selections": [
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DoorUnlockPollingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UnlockRequest",
        "kind": "LinkedField",
        "name": "unlockRequest",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "reservation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1fe827c5744605dfce5c280ded08b9bc",
    "id": null,
    "metadata": {},
    "name": "DoorUnlockPollingQuery",
    "operationKind": "query",
    "text": "query DoorUnlockPollingQuery(\n  $unlockRequestId: UUID!\n) {\n  unlockRequest(id: $unlockRequestId) {\n    id\n    status\n    error\n    unlockedAt\n    reservation {\n      __typename\n      space {\n        id\n        status\n        hub {\n          status\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1c7d0107fab191c7ccb0d11549efa80";

export default node;
